import { z } from "zod";

export const CreativeFlagComponentSchema = z.enum(["OPPORTUNITY", "OVERVIEW", "DRILLDOWN"]);
export type CreativeFlagComponent = z.infer<typeof CreativeFlagComponentSchema>;

export const CreateCreativeFlagRequestSchema = z.object({
  creativeHash: z.string().min(1).max(500),
  adId: z.string().max(255).optional(),
  competitor: z.string().max(100).optional(),
  reason: z.string().trim().min(1).max(2000),
  component: CreativeFlagComponentSchema,
  contextLabel: z.string().min(1).max(500),
  // shared classification (optional)
  feature: z.string().max(255).optional(),
  subFeature: z.string().max(255).optional(),
  industry: z.string().max(255).optional(),
  engine: z.string().max(255).optional(),
  // opportunity-specific (optional)
  flowName: z.string().max(255).optional(),
  opportunityId: z.number().int().optional(),
  opportunitySetId: z.string().optional(),
  segment1: z.string().max(500).optional(),
  segment2: z.string().max(500).optional(),
  segment3: z.string().max(500).optional(),
});
export type CreateCreativeFlagRequest = z.infer<typeof CreateCreativeFlagRequestSchema>;

export const CreativeFlagDtoSchema = z.object({
  id: z.string(),
  creativeHash: z.string(),
  reason: z.string(),
  component: CreativeFlagComponentSchema,
  contextLabel: z.string(),
  // shared classification (nullable)
  feature: z.string().nullable(),
  subFeature: z.string().nullable(),
  industry: z.string().nullable(),
  engine: z.string().nullable(),
  // opportunity-specific (nullable)
  flowName: z.string().nullable(),
  opportunityId: z.number().int().nullable(),
  opportunitySetId: z.string().nullable(),
  segment1: z.string().nullable(),
  segment2: z.string().nullable(),
  segment3: z.string().nullable(),
  createdAt: z.string(), // ISO
  reporterName: z.string(),
  reporterEmail: z.string(),
});
export type CreativeFlagDto = z.infer<typeof CreativeFlagDtoSchema>;
